(function () {
  var bar = document.querySelector('[data-p4p-sticky]');
  if (!bar) return;
  var mainBtn = document.querySelector('product-form button[name="add"], .product-form__submit');
  if (!mainBtn) return;
  // Dawn's scroll-trigger animation leaves a transform on the product-info
  // wrapper, which would become the containing block for position:fixed —
  // reparent to <body> so the bar pins to the real viewport.
  document.body.appendChild(bar);
  // Show the bar only when the real button is off-screen AND on a narrow viewport.
  var narrow = window.matchMedia('(max-width: 749px)');
  var ticking = false;
  function offScreen() {
    var r = mainBtn.getBoundingClientRect();
    return r.bottom <= 0 || r.top >= window.innerHeight;
  }
  function update() { bar.hidden = !(narrow.matches && offScreen()); ticking = false; }
  function requestUpdate() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', requestUpdate, { passive: true });
  if (narrow.addEventListener) narrow.addEventListener('change', requestUpdate);
  update();
  bar.querySelector('[data-p4p-sticky-add]').addEventListener('click', function () { mainBtn.click(); });
})();
